import React from "react";
import { DocumentLibrary } from "@/components/customer/DocumentLibrary";

export default function WiringDiagrams() {
  return (
    <DocumentLibrary
      overline="Technical"
      title="Wiring Diagrams"
      subtitle="Customer-accessible wiring and electrical schematics for your On The Move caravan systems."
      docType="wiring_diagram"
      emptyHint="Approved wiring diagrams will appear here once published by your administrator."
    />
  );
}
